// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__ysR5s","content":"Layout_content__JLT39"};